// Projects data.
// Note: Here we are getting data from a js file, but in a different project I'll be fetching these projects from some srt of APIs.

const projects = [
	{
		id: 1,
		title: 'Instruo',
		category: 'Web Application',
		img: require('@/assets/images/instruo.png'),
	},
	{
		id: 2,
		title: 'MangaSlice',
		category: 'Web Application',
		img: require('@/assets/images/mangaslice.png'),
	},
	{
		id: 3,
		title: 'Connectre-B',
		category: 'Web Application',
		img: require('@/assets/images/connectre-b.png'),
	},
	{
		id: 4,
		title: 'Xperience',
		category: 'Web Application',
		img: require('@/assets/images/xperience.png'),
	},
	{
		id: 5,
		title: 'GovAccess',
		category: 'Mobile Application',
		img: require('@/assets/images/govaccess.png'),
	},
	{
		id: 6,
		title: 'Augmented Faces',
		category: 'Mobile Application',
		url: '',
		img: require('@/assets/images/augmented_faces.png'),
	},
	{
		id: 7,
		title: 'SoulSwipe',
		category: 'Mobile Application',
		img: require('@/assets/images/soulswipe.png'),
	},
	{
		id: 8,
		title: 'Photo81',
		category: 'Web Application',
		img: require('@/assets/images/photo81.png'),
	},
	{
		id: 9,
		title: 'Takeda CryptoLending',
		category: 'Web Application',
		img: require('@/assets/images/takeda_cryptolending.png'),
	},
	{
		id: 10,
		title: 'Calcmenu',
		category: 'Web Application',
		url: 'https://www.calcmenu.com',
		img: require('@/assets/images/calcmenu.png'),
	},
];

export default projects;
